import LaurentMekies from "./laurent_mekies.png"
import GianPieroLambiase from "./gianpiero_lambiase.png"
import PierreWache from "./pierre_wache.png"
import RichardWolverson from "./richard_wolverson.png"
import HannahSchmitz from "./hannah_schmitz.png"
import RichardWood from "./richard_wood.jpg"
import StephenKnowles from "./stephen_knowles.png"

export const pictures = {
    LaurentMekies,
    GianPieroLambiase,
    PierreWache,
    RichardWolverson,
    HannahSchmitz,
    RichardWood,
    StephenKnowles
}
